export enum ISOCountryCode {
  MY = "Malaysia",
  SG = "Singapore",
  ID = "Indonesia",
  TH = "Thailand"
}
